export class AggressiveCacheOptions {
    public duration: number;
}
